import { createEntityAdapter } from '@reduxjs/toolkit'

import { PlanningInboxGridRow } from '../model/planning/PlanningInboxGridRow'

export const planningInboxRowsAdapter = createEntityAdapter({
  selectId: (row: PlanningInboxGridRow) => row.id,
})

